module.exports = __webpack_public_path__ + "assets/img/icon_audio.bceb5aff.png";